import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ActionType, AppState } from "../store/Page.Actions";
import { useNavigate } from "react-router-dom";

export function UserState()
{
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [userDetails, setUserDetails] = useState({
        User_ID: 0,
        UserName: '',
        Email: '',
        DateOfBirth: '',
        Password: '',
        Token: '',
        UpdatedDate: '',
        Status: '',
        ProfileImage: '',
        Blocked: '',
        badge : '',
        ViewName:''
        
    });

const setUserState=(uDetails:any)=>
{
    dispatch({
        type: ActionType.STORE,
        payload: {
          storeData: uDetails,
          viewName: uDetails.ViewName,
        },
      });
     // setUserDetails(uDetails);
}


const userStoreDetails = useSelector((state: AppState) =>
{
   // debugger;
   
  return   typeof(state.storeData.Login)!='undefined'?state.storeData.Login:{
    User_ID: 0,
    UserName: '',
    Email: '',
    DateOfBirth: '',
    Password: '',
    Token: '',
    UpdatedDate: '',
    Status: '',
    ProfileImage: '',
    Blocked: '',
    badge : '',
    ViewName:''
    
}; 
}
);

const getUserState=()=>
{
    
let stateDetails={...userStoreDetails}
    setUserDetails(stateDetails);


}

// useEffect(()=>
// {
//     getUserState();
// });


const onLogOut=()=>
{
    setUserState({
        User_ID: 0,
        UserName: '',
        Email: '',
        DateOfBirth: '',
        Password: '',
        Token: '',
        UpdatedDate: '',
        Status: '',
        ProfileImage: '',
        Blocked: '',
        badge : '',
        ViewName:''
    })
    navigate('/');

}


    return {onLogOut,userDetails,setUserState,userStoreDetails}
}